import { InjectionToken } from '@angular/core';

export type AuthDataConfig = {
  apiPrefix: string;
};

export const AUTH_DATA_CONFIG = new InjectionToken<AuthDataConfig>(
  'auth-data-config',
);
